


export type BillDetailComponentType = 'Header' | 'Creditor' | 'Activity' | 'Chat' | 'Document' | 'Positions';

export const BillDetailComponentType = {
    Header: 'Header' as BillDetailComponentType,
    Creditor: 'Creditor' as BillDetailComponentType,
    Activity: 'Activity' as BillDetailComponentType,
    Chat: 'Chat' as BillDetailComponentType,
    Document: 'Document' as BillDetailComponentType,
    Positions: 'Positions' as BillDetailComponentType
};

